export const BASETRIAL_PROMOTION_ALIAS = 'basetrial';
export const GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS = 'getclasspass';
export const OFFER_BANNER_ID = 'offer_banner';
export const PROMOTIONS_CMS_MODULES_ENABLED = 'promotions_cms_modules_web';
